import { configService } from "../index";
import Experience from "../../models/experience";
import { BaseRequests } from "./BaseRequests";
import { BaseRequestsInterface } from "./BaseRequests";

export default {
  ...BaseRequests(
    () => configService.cellarExperiences,
    "experience",
    () => new Experience()
  )
} as BaseRequestsInterface;
